import {createBrowserHistory} from 'history';
import { maestroenv } from './maestroenv';

export const history = createBrowserHistory({
  basename: maestroenv.PUBLIC_URL
});
